import React, { useEffect, useState } from "react";
import "../../assets/styles/preTreatmentReport.scss";
import rcIcon from "../../assets/images/image 1.png";
import { mask, wrapList } from "../../utils/utils";
import { commonPostApi } from "../../utils/apiService";
import { API_ENDPOINTS } from "../../utils/apiEndpoints";

const PostTreatmentReport = ({id}) => {

  const [treatment, setTreatment] = useState();
  // Eye examination data
  const [examinationDetails, setExaminationDetails] = useState([
    { label: "Visual Acuity", LDO: "123", RDO: "123", api_key: "va" },
    { label: "Intraocular Pressure", LDO: "123", RDO: "123", api_key: "iop" },
    { label: "Auto Refraction", LDO: "123", RDO: "123", api_key: "auto_refraction" },
    { label: "Dilated Refraction", LDO: "123", RDO: "123", api_key: "refraction_dilated" },
    { label: "PGP", LDO: "123", RDO: "123" , api_key:"pgp"},
    { label: "Glasses Prescription", LDO: "123", RDO: "123", api_key: "glasses_prescription" },
    { label: "Intermediate Glasses Prescription", LDO: "123", RDO: "123", api_key:"intermediate_glasses_prescription" },
    { label: "PMT", LDO: "123", RDO: "123", api_key: "pmt" },
    { label: "Retinoscopy", LDO: "123", RDO: "123", api_key: "retinoscopy" },
    { label: "Keratometry", LDO: "123", RDO: "123", api_key: "keratometry" },
    { label: "Amsler", LDO: "123", RDO: "123", api_key: "amsler" },
    { label: "Contact Lens Prescription", LDO: "123", RDO: "123", api_key: "contact_lens_prescription" },
    { label: "Color Vision", LDO: "123", RDO: "123" , api_key: "color_vision"},
    { label: "Contrast Sensitivity", LDO: "123", RDO: "123" , api_key: "contrast_sensitivity"},
    { label: "Orthoptics", LDO: "123", RDO: "123", api_key: "orthoptics" },
    { label: "Other", LDO: "123", RDO: "123" , api_key: "others"},
  ])

  useEffect(() =>{
      commonPostApi(API_ENDPOINTS.PATIENT_POSTTREATMENT_REPORT,{
      "patient_id" : id
   }).then(data =>{
    setTreatment(data?.data?.data?? {})
  })
    }, [] 
  )

  useEffect(()=>{
    
  const [left_eye] = treatment?.patientvisiteyeexam?.filter(item=>item?.eye_type == "Left Eye")?? []
  const [right_eye] = treatment?.patientvisiteyeexam?.filter(item=>item?.eye_type == "Right Eye")?? []

    setExaminationDetails(prev=>{
      return prev?.map(
        item=>({...item, LDO: left_eye?.[item?.api_key]?? "-", RDO: right_eye?.[item?.api_key]?? "-"})
      )
    })
  }, [treatment])
  const [left_eye] = treatment?.patientvisiteyeexam?.filter(item=>item?.eye_type == "Left Eye")?? []
  const [right_eye] = treatment?.patientvisiteyeexam?.filter(item=>item?.eye_type == "Right Eye")?? []

  return (
    <div className="post-treatment-report Pre-Treatment-Report-print-page2">
    <div className="headline">
      <div className="flex gap-2">
        <img src={rcIcon} width="24" height="24"/>
        <div>Vital Impact</div>
      </div>
    </div>
    <div className="sub p-4">
      <div className="pre-button">Post-Treatment Details</div>
    </div>
    <div className="treatment-details pb-4">
      <div className="pre-detail-item">
        <span className="front">Camp Details</span>{" "}
        <span className="brief">{treatment?.camp_name?? "-"}</span>
      </div>
      <div className="pre-detail-item">
        <span className="front">Patient name</span>{" "}
        <span className="brief">{treatment?.patient_name?? "-"}</span>
      </div>
      <div className="pre-detail-item">
        <div className="front">Patient ID</div>
        <div className="brief">{treatment?.patient_code?? "-"}</div>
      </div>
      <div className="right">
        <div className="front">Patient Aadhaar Number</div>
        <div className="brief">{treatment?.aadhar_no? mask(treatment?.aadhar_no) : "-"}</div>
      </div>
    </div>
    
    <div className="pt-4">
      <div className="parameter">Patient Vital Parameters</div>
      <div className="vitals-row pt-2 pb-4">
        <div className="vital-item">
          <div className="mark">Age</div>
          <div className="brief">{treatment?.age?? "-"}</div>
        </div>
        <div className="vital-item text-center">
          <div className="mark">Height</div>
          <div className="brief">{treatment?.height?? "-"}</div>
        </div>
        <div className="vital-item text-center">
          <div className="mark">Weight</div>
          <div className="brief">{treatment?.weight?? "-"}</div>
        </div>
        <div className="vital-item text-center">
          <div className="mark">pulse</div>
          <div className="brief">{treatment?.pulse} bpm</div>
        </div>
        <div className="vital-item text-right">
          <div className="mark">Blood Pressure</div>
          <div className="brief">{treatment?.blood_pressure} mm Hg</div>
        </div>
      </div>
    </div>
      <div className="summary-sections pb-4">
        <div className="flex justify-content-between">
        <div className="flex-1">
          <div className="front pt-4">Patient Condition</div>
          <span className="brief">Space to write summary of the treatment done Space to write summary of the treatment Space to write summary of the treatment space</span>
        </div>
        <div className="flex-1 pl-4">
          <div className="front pt-4">Treatment Summary</div>
          <span className="brief">Space to write summary of the treatment done Space to write summary of the treatment one Space to write summary of the treatment done space to write summary of the treatment done</span>
        </div>
        </div>
      </div>

      <div className="summary-sections pb-4">
        <div className="flex justify-content-between">
        <div className="flex-1">
          <div className="front pt-4">Medicine Details</div>
          <span className="brief">Space to write summary of the treatment done</span>
        </div>
        <div className="flex-1 pl-4">
          <div className="front pt-4">Diet</div>
          <span className="brief">Space to write summary of the treatment done</span>
        </div>
        </div>
      </div>

      <div className="dry-refraction-container">
        {/* Title */}
        <div className="front main-label pt-3">Dry Refraction</div>
      </div>
      
            {/* Tables Container */}
            <div className="tables-container mb-3">
              <div className="flex flex-column w-full">
                <div className="left-vision main-label text-center">L/DO</div>
                <div className="table-section">
                  <table>
                    <thead className="brief">
                      <tr className="brief">
                        <th className="main-label-sec font-normal font-13px">Type</th>
                        <th className="main-label-sec font-normal font-13px">Sph</th>
                        <th className="main-label-sec font-normal font-13px">Ne.</th>
                        <th className="main-label-sec font-normal font-13px">Axis</th>
                        <th className="main-label-sec font-normal font-13px">Vis</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="brief main-label-sec">Distance</td>
                        <td>{left_eye?.distance_sph?? "-"}</td>
                        <td>{left_eye?.distance_necylar?? "-"}</td>
                        <td>{left_eye?.distance_axis?? "-"}</td>
                        <td>{left_eye?.distance_vision?? "-"}</td>
                      </tr>
                      <tr>
                        <td className="brief main-label-sec">Near</td>
                        <td>{left_eye?.near_sph?? "-"}</td>
                        <td>{left_eye?.near_necylar?? "-"}</td>
                        <td>{left_eye?.near_axis?? "-"}</td>
                        <td>{left_eye?.near_vision?? "-"}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
      
              {/* Divider */}
              <div className="vertical-line"></div>
      
              <div className="flex flex-column w-full">
                <div className="text-center main-label left-vision">R/DO</div>
                <div className="table-section">
                  <table>
                    <thead>
                      <tr className="main-label-sec">
                        <th className="main-label-sec font-normal font-13px">Type</th>
                        <th className="main-label-sec font-normal font-13px">Sph</th>
                        <th className="main-label-sec font-normal font-13px">Ne.</th>
                        <th className="main-label-sec font-normal font-13px">Axis</th>
                        <th className="main-label-sec font-normal font-13px">Vis</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="brief main-label-sec">Distance</td>
                        <td>{right_eye?.distance_sph?? "-"}</td>
                        <td>{right_eye?.distance_necylar?? "-"}</td>
                        <td>{right_eye?.distance_axis?? "-"}</td>
                        <td>{right_eye?.distance_vision?? "-"}</td>
                      </tr>
                      <tr>
                        <td className="brief main-label-sec">Near</td>
                        <td>{right_eye?.near_sph?? "-"}</td>
                        <td>{right_eye?.near_necylar?? "-"}</td>
                        <td>{right_eye?.near_sph?? "-"}</td>
                        <td>{right_eye?.near_vision?? "-"}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
      
            <div className="summary-sections pt-3"></div>
            {/* Eye Examination Details Section */}
            <div className="eye-examination-details">
              <div className="front main-label pt-3 text-center">Eye Examination Details</div>
      
              <div className="tables-container">
                {/* L/DO Table */}
                <div className="table-container">
                  <div className="front main-label pt-3 text-center">L/DO</div>
                  <div className="exam-table p-1rem">
                    <div>
                      {wrapList(examinationDetails).map((item, index) => (
                        <div className="" key={index}>
                          <div className="flex justify-content-between">
                            {item?.map((list, ind) => (
                              <>
                                {ind == 1 && <div className="divider my-2" />}
                                <div className="flex flex-column flex-1 pl-20px p-2">
                                  <div className="main-label Outline front">{list.label}</div>
                                  <div className="Benefit main-label front">{list.LDO}</div>
                                </div>
                              </>))}
                          </div>
                          <div className="Boundary"></div>
      
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
      
                {/* Divider */}
                <div className="standing-stroke"></div>
      
                {/* R/DO Table */}
                <div className="table-container">
                  <div className="front main-label pt-3 text-center">R/DO</div>
                  <table className="exam-table p-1rem">
                    <div>
                      {wrapList(examinationDetails).map((item, index) => (
                        <div className="" key={index}>
                          <div className="flex justify-content-between">
                            {item?.map((list, ind) => (
                              <>
                                {ind == 1 && <div className="divider my-2" />}
                                <div className="flex flex-column flex-1 pl-20px p-2">
                                  <div className="Outline main-label front">{list.label}</div>
                                  <div className="Benefit main-label front">{list.LDO}</div>
                                </div>
                              </>))}
                          </div>
                          <div className="Boundary"></div>
      
                        </div>
                      ))}
                    </div>
                  </table>
                </div>
              </div>
            </div>
    </div>
  );
};

export default PostTreatmentReport;
